import { clubbiStyled } from 'clubbi-ui'
import { Link } from 'react-router-dom'

export const StyledAbasteceShopBanner = clubbiStyled('div')(({ theme }) => ({
  maxWidth: '1200px',
  margin: '0 auto',
  padding: '20px 20px 0 20px',
  borderRadius: '10px',
  [theme.breakpoints.up('md')]: {
    padding: ' 0 28px',
  },
}))

export const StyledAbasteceShopBannerLink = clubbiStyled(Link)({
  width: '100%',
  display: 'block',
})

export const StyledAbasteceShopBannerImage = clubbiStyled('img')({
  width: '100%',
  borderRadius: '10px',
  height: 'auto',
  display: 'block',
})
